import request from "@/utils/request";

export function fetchList(param) {
  return request({
    url: 'api/console/alarm/push/list',
    method: 'post',
    data: param
  })
}

export function fetchAlarm() {
    return request({
        url: 'api/console/alarm/push/get/types',
        method: 'post'
    })
}

export function alarmCreate(param) {
  return request({
    url: 'api/console/alarm/push/create',
    method: 'post',
    data: param
  })
}

export function alarmDelete(param) {
  return request({
    url: 'api/console/alarm/push/delete',
    method: 'post',
    data: param
  })
}

export function alarmSwitch(param) {
  return request({
    url: 'api/console/alarm/push/enable',
    method: 'post',
    data: param
  })
}